module.exports = __webpack_public_path__ + "img/msi-img-second.8669df40.png";